import { Box, BoxProps, Radio, RadioGroup, SxProps, Theme, styled } from '@mui/material';
import { ChangeEvent, useCallback } from 'react';

interface ISwitchProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  sx?: SxProps<Theme>;
  disabled?: boolean;
}

const RadioIcon = styled(Box)<BoxProps & { checked?: boolean }>({
  padding: '3px',
  borderRadius: '4px',
  fontWeight: '600',
  background: 'inherit',
  variants: [
    {
      props: ({ checked }) => checked,
      style: {
        background: 'white',
      },
    },
  ],
});

const RadioSwitch = ({ value, onChange, options, sx, disabled }: ISwitchProps) => {
  const onValueChange = useCallback(
    (_event: ChangeEvent<HTMLInputElement>, changeValue: string) => onChange(changeValue),
    [onChange],
  );

  return (
    <RadioGroup
      sx={{
        background: '#F0F1F2',
        borderRadius: '6px',
        padding: '4px',
        gap: '5px',
        flexWrap: 'nowrap',
        ...sx,
      }}
      value={value}
      row
      onChange={onValueChange}
    >
      {options.map(item => (
        <Radio
          sx={{
            borderRadius: 'inherit',
            padding: '1px',
          }}
          value={item}
          key={item}
          checkedIcon={<RadioIcon checked>{item}</RadioIcon>}
          icon={<RadioIcon>{item}</RadioIcon>}
          disabled={disabled}
        />
      ))}
    </RadioGroup>
  );
};

export default RadioSwitch;
